/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/5/17
 * Copyright All Rights Reserved
 */

/**
 * Checks whether a token is valid as far as the client is concerned
 *
 * @param {string} token a JSON web token
 */
const isValid = token => !!token;
// TODO: The isValid function needs to be fleshed out. Currently, it is only a placeholder
export default {
  isValid,
};
